export const SHOP_TYPE = {
  GROCERY: 'grocery',
  RESTAURANT: 'restaurant'
}

export const ORDER_ACCEPT_TYPE = {
  ONDEMAND: 'ondemand',
  PREORDER: 'preorder'
}